<template>
  <div class="custom-input-container">
    <input
      :type="type"
      :value="value"
      :placeholder="placeholder"
      :disabled="disabled"
      :maxlength="maxlength"
      @input="handleInput"
      @focus="handleFocus"
      @blur="handleBlur"
      class="custom-input"
    />
    <div v-if="error" class="custom-input-error">{{ error }}</div>
  </div>
</template>

<script>
export default {
  name: 'CustomInput',
  props: {
    value: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    placeholder: {
      type: String,
      default: ''
    },
    error: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    maxlength: {
      type: [String, Number],
      default: null
    }
  },
  methods: {
    handleInput(event) {
      this.$emit('input', event.target.value);
    },
    handleFocus() {
      this.$emit('focus');
    },
    handleBlur() {
      this.$emit('blur');
    }
  }
};
</script>

<style scoped>
.custom-input-container {
  position: relative;
  width: 100%;
}

.custom-input {
  width: 100%;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 1rem;
  color: #1a1a1a !important;
  background-color: #fff !important;
  transition: all 0.2s ease;
  outline: none;
  box-sizing: border-box;
}

.custom-input:focus {
  border-color: #6772e5;
  box-shadow: 0 0 0 3px rgba(103, 112, 229, 0.1);
}

.custom-input:disabled {
  background-color: #f8fafc;
  cursor: not-allowed;
}

.custom-input-error {
  color: #e23744;
  font-size: 0.875rem;
  margin-top: 0.5rem;
  padding: 0.5rem;
  border-radius: 4px;
  background-color: #fee2e2;
}

/* Placeholder styles */
.custom-input::placeholder {
  color: #94a3b8 !important;
  font-weight: 400;
}

/* Hover states */
.custom-input:hover:not(:disabled) {
  border-color: #d1d5db;
}

/* Focus states */
.custom-input:focus {
  border-color: #6772e5;
  box-shadow: 0 0 0 3px rgba(103, 112, 229, 0.1);
}

/* Disabled state */
.custom-input:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

</style>
